export default "__VITE_ASSET__CVR0eOiy__"